import React, { useState } from "react";

import { ListWithCheck, Plus, Scan, Upload, Download } from "icons";
import { Link } from "react-router-dom";

import { Typography } from "clearsense-ui/components";
import ContentBox from "components/Common/ContentBox";

import SelectReferenceSource from "./SelectReferenceSource";

import CreateFromUniqueValues from "../Pane/CreateFromUniqueValues";
import CreateReferenceSource from "../Pane/CreateReferenceSource";
import UploadReferenceSource from "../Pane/UploadReferenceSource";

const ListElement = ({ icon, content = "", onClick }) => (
  <Typography
    style="condensedMedium"
    type="semibold"
    className="flex items-center gap-2 p-2 transition duration-300 cursor-pointer hover:bg-gray-200 w-max"
    onClick={onClick}
  >
    {icon}
    {content}
  </Typography>
);

const AddReferenceSources = ({
  dsde,
  dataSource,
  cde,
  fetchAssociatedReferenceSource,
}) => {
  const [isSelectReferenceSourceOpen, setIsReferenceSourceOpen] =
    useState(false);
  const [isUploadReferenceSource, setIsUploadReferenceSource] = useState(false);
  const [isCreateFromUniqueValuesOpen, setIsCreateFromUniqueValuesOpen] =
    useState(false);
  const [isCreateReferenceSourceOpen, setIsCreateReferenceSourceOpen] =
    useState(false);
  return (
    <ContentBox className="mx-6 text-black dark:text-gray-400">
      <Typography style="h4" type="semibold">
        Add Reference Source
      </Typography>
      <div className="m-2">
        <ListElement
          icon={<ListWithCheck color="gray" size={15} />}
          content="Use an Existing Reference Source"
          onClick={() => setIsReferenceSourceOpen(true)}
        />
        <div className="flex items-center">
          <ListElement
            icon={<Upload color="gray" size={15} />}
            content="Upload Reference Source"
            onClick={() => setIsUploadReferenceSource(true)}
          />
          <Link to="/sample_reference_source.csv" target="_blank" download>
            <Typography
              style="small"
              className="flex items-center gap-2 text-indigo-600 dark:text-indigo-400"
            >
              [<Download size={15} /> Download Reference Data Template ]
            </Typography>
          </Link>
        </div>
        <ListElement
          icon={<Scan color="gray" size={15} />}
          content="Create From Unique Value of DSDE"
          onClick={() => setIsCreateFromUniqueValuesOpen(true)}
        />
        <ListElement
          icon={<Plus color="gray" size={15} />}
          content="Create New Reference Source"
          onClick={() => setIsCreateReferenceSourceOpen(true)}
        />
      </div>
      {isSelectReferenceSourceOpen && (
        <SelectReferenceSource
          isPaneOpen={isSelectReferenceSourceOpen}
          setIsPaneOpen={setIsReferenceSourceOpen}
          dsde={dsde}
          fetchAssociatedReferenceSource={fetchAssociatedReferenceSource}
        />
      )}
      <UploadReferenceSource
        isPaneOpen={isUploadReferenceSource}
        setIsPaneOpen={setIsUploadReferenceSource}
        dataSource={dataSource}
        dsde={dsde}
        fetchAssociatedReferenceSource={fetchAssociatedReferenceSource}
      />
      <CreateFromUniqueValues
        isPaneOpen={isCreateFromUniqueValuesOpen}
        setIsPaneOpen={setIsCreateFromUniqueValuesOpen}
        dataSource={dataSource}
        cde={cde}
        fetchAssociatedReferenceSource={fetchAssociatedReferenceSource}
      />
      <CreateReferenceSource
        isPaneOpen={isCreateReferenceSourceOpen}
        setIsPaneOpen={setIsCreateReferenceSourceOpen}
        dataSource={dataSource}
        cde={cde}
        fetchAssociatedReferenceSource={fetchAssociatedReferenceSource}
      />
    </ContentBox>
  );
};

export default AddReferenceSources;
